<template>
	<div class="layer-project" data-project-name="ipark-duty-free">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						<span class="award13"></span>SHILLA IPARK duty free
					</h1>
					<a href="http://store.shillaipark.com" class="link" target="_blank"
						>store.shillaipark.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						다양한 쇼핑 정보를 편리하게 찾아볼 수 있도록 사용자 편의성을 고려한
						UI/UX를 설계하고, 최신 트렌드를 적용하여 신라아이파크면세점을
						효과적으로 홍보 할 수 있도록 제작하였습니다.
						<span
							>각 디바이스별로 콘텐츠를 제작, 접속 환경별 디바이스에 최적화된
							UI로 서비스를 제공하고 SNS 공유 및 연동기능을 통한 마케팅 채널
							역할을 강화했습니다.</span
						>
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li class="item01">HDC <br />Group</li>
							<li class="item02">I’PARK MALL</li>
							<li class="item03">The SHILLA <br />duty free</li>
						</ul>
						<ul class="diagram02">
							<li class="item01">
								SHILLA IPARK <br />duty free
								<span>The Must Visit Place in Korea</span>
							</li>
						</ul>
					</div>
				</div>
			</section>

			<!-- Details [e] -->
			<section class="section full section01">
				<div class="inner-section">
					<div class="pc-web-wrap">
						<strong class="project-subtit">PC Web</strong>
						<p class="sub-text">
							SHILLA IPARK duty free의 건물의 실내외 이미지와 모델이미지로
							작업한 배너형 디자인으로 고급스럽고 트렌디한 이미지를 시각적으로
							표현하고,
							<span
								>원형과 육각형 등 도형을 활용한 배너와 이미지로 다양한 정보를
								통일성 있게 구성하여 사용자가 정보를 쉽게 이해할 수 있도록
								제작했습니다.</span
							>
						</p>
					</div>
					<!-- Swiper -->
					<div class="pc-web-slider swiper-container">
						<ul class="swiper-wrapper clfix">
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ipark-duty-free/pc-web-img-01@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ipark-duty-free/pc-web-img-02@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ipark-duty-free/pc-web-img-03@m.png"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ipark-duty-free/pc-web-img-04@m.png"
								/>
							</li>
						</ul>

						<!-- Add Pagination -->
						<div class="swiper-pagination"></div>
					</div>
					<div class="pc-web-polygon clfix">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/pc-web-img-05-01@m.png"
							/>
						</div>
					</div>
					<div class="pc-web-img-wrap clfix">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/pc-web-img-06-01@m.png"
							/>
						</div>
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/pc-web-img-06-02@m.png"
							/>
						</div>
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/pc-web-img-06-03@m.png"
							/>
						</div>
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/pc-web-img-06-04@m.png"
							/>
						</div>
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/pc-web-img-06-05@m.png"
							/>
						</div>
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/pc-web-img-06-06@m.png"
							/>
						</div>
					</div>
				</div>
			</section>

			<section class="section full section02">
				<div class="inner-section">
					<div class="mobile-web-wrap">
						<strong class="project-subtit">Mobile Web</strong>
						<p class="sub-text">
							모바일 접속 시 중요한 기능을 아이콘화함으로써 접근성을 강화하고,
							<span
								>모바일 디바이스의 특성에 맞게 디자인을 변경하였습니다.</span
							>
						</p>
					</div>
					<div class="mobile-img-wrap clfix">
						<div class="img item01">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/mobile-web-img-01@m.png"
							/>
						</div>
						<div class="img item02">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/mobile-web-img-02@m.png"
							/>
						</div>
						<div class="img item03">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/mobile-web-img-03@m.png"
							/>
						</div>
						<div class="img item04">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/mobile-web-img-04@m.png"
							/>
						</div>
					</div>
					<div class="mobile-web-polygon clrfix">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/mobile-web-img-05@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="section section03">
				<div class="inner-section">
					<div class="point-top-wrap clfix">
						<div class="font-area">
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ipark-duty-free/font-img@m.png"
								/>
							</div>
						</div>
						<ul class="color-area clfix">
							<li class="item01">#e83030</li>
							<li class="item02">#8d7865</li>
							<li class="item03">#453b31</li>
							<li class="item04">#333333</li>
						</ul>
					</div>
					<div class="icon-area">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ipark-duty-free/icon-img@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">SHILLA IPARK duty free</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var pcwebSwiper = new Swiper(".pc-web-slider", {
			spaceBetween: 80,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			breakpoints: {
				// when window width is <= 712px
				711: {
					centeredSlides: true,
					spaceBetween: 15,
				},
				1279: {
					spaceBetween: 40,
				},
			},
		});
	},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/swiper.min.css"; /* if use swiper.min.js */
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
.sub-text {
	word-break: keep-all;
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/ipark-duty-free/ci.png) 50% / auto
		55px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ipark-duty-free/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ipark-duty-free/bg-overview@t.jpg);
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ipark-duty-free/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 110px;
	}
}

/* Overview */
.project-overview {
	background-color: #c8352e;
	color: #fff;
}
.project-overview-txt {
	margin-bottom: 24px;
}
.project-overview-txt span {
	display: inline-block;
}
.project-overview-diagram ul {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
}
.project-overview-diagram li {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 138px;
	height: 138px;
	padding: 10px;
	line-height: 1.7rem;
	font-weight: 500;
	border-radius: 50%;
	text-align: center;
}
.project-overview-diagram .diagram01 {
	position: relative;
}
.project-overview-diagram .diagram01:after {
	content: "";
	position: absolute;
	bottom: 10px;
	left: 50%;
	width: 1px;
	height: 41.5px;
	background-color: #fff;
}
.project-overview-diagram .diagram01 li {
	border: 1px solid #fff;
}
.project-overview-diagram .diagram01 .item02 {
	margin-left: -7px;
}
.project-overview-diagram .diagram02 li {
	flex-direction: column;
	font-size: 1.6rem;
	background-color: #fff;
	color: #c8352e;
}
.project-overview-diagram .diagram02 li span {
	display: block;
	margin-top: 5px;
	padding: 0 10px;
	font-size: 1.2rem;
	color: #c24444;
}
@media screen and (max-width: 711px) {
	.project-overview-diagram .diagram01 {
		padding-bottom: 30px;
	}
	.project-overview-diagram .diagram01 .item03 {
		margin-top: -25px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-txt {
		margin-bottom: 30px;
	}
	.project-overview-txt span {
		display: inline;
	}
	.project-overview-diagram {
		display: flex;
		justify-content: space-between;
		max-width: 632px;
		margin: 0 auto;
	}
	.project-overview-diagram ul {
		display: inline-flex;
	}
	.project-overview-diagram .diagram01 {
		padding-right: 68px;
	}
	.project-overview-diagram .diagram01 .item03 {
		margin-left: -7px;
	}
	.project-overview-diagram .diagram01:after {
		top: 50%;
		left: auto;
		right: 0;
		width: 89px;
		height: 1px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		padding-top: 26px;
		padding-bottom: 15px;
	}
	.project-overview-txt {
		margin-bottom: 55px;
	}
	.project-overview-txt span {
		display: inline-block;
	}
	.project-overview-diagram {
		max-width: 1240px;
		padding-left: 30px;
		padding-right: 30px;
	}
	.project-overview-diagram li {
		width: 246px;
		height: 246px;
		padding: 34px;
	}
	.project-overview-diagram .diagram01 {
		padding-right: 192px;
	}
	.project-overview-diagram .diagram01:after {
		width: 162px;
		height: 2px;
	}
	.project-overview-diagram .diagram01 li {
		font-size: 20px;
		border-width: 2px;
		line-height: 1.5;
	}
	.project-overview-diagram .diagram02 li {
		font-size: 28px;
		line-height: 32px;
	}
	.project-overview-diagram .diagram02 li span {
		font-size: 16px;
		line-height: 1.8;
	}
}

/* PC Web */
.section.full.section01 {
	padding-bottom: 0;
}
.pc-web-wrap {
	margin-bottom: 30px;
	padding: 0 15px;
}
.pc-web-slider {
	margin-bottom: 45px;
	padding: 0 15px 40px;
}
.pc-web-slider li {
	text-align: center;
}
.pc-web-slider li img {
	box-shadow: 0 16px 20px rgba(0, 0, 0, 0.22);
}
.pc-web-polygon {
	position: relative;
	margin-bottom: 40px;
	background: url(/static/img/project-detail/ipark-duty-free/pc-web-bg-polygon@m.png)
		no-repeat;
	background-size: 100% auto;
	background-position-y: 12.03125vw;
}
.pc-web-polygon:before {
	content: "";
	position: absolute;
	top: 10.3125vw;
	left: -50px;
	width: 42.5vw;
	height: 42.5vw;
	background: url(/static/img/project-detail/ipark-duty-free/pc-web-img-05-02@m.png)
		no-repeat;
	background-size: 100% auto;
}
.pc-web-polygon .img {
	position: relative;
	text-align: right;
}
.pc-web-polygon .img img {
	width: 80.9375vw;
}
.pc-web-img-wrap > div {
	float: left;
	width: 50%;
}
.pc-web-img-wrap .img img {
	width: 100%;
	max-width: none;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.pc-web-wrap {
		padding: 0 40px;
	}
	.pc-web-slider {
		padding: 0 40px 40px;
	}
	.pc-web-polygon {
		padding: 0 40px;
		background-image: url(/static/img/project-detail/ipark-duty-free/pc-web-bg-polygon@t.png);
		background-position-y: 7.3033vw;
	}
	.pc-web-polygon:before {
		top: 10.8146vw;
		left: 40px;
		width: 33.9185vw;
		height: 33.9185vw;
		background-image: url(/static/img/project-detail/ipark-duty-free/pc-web-img-05-02@t.png);
		background-size: 100% auto;
	}
	.pc-web-polygon .img img {
		width: 60.95505vw;
	}
	.pc-web-img-wrap .img {
		width: 33.3333%;
	}
	.pc-web-img-wrap img {
		height: 18.8202vw;
	}
}
@media screen and (min-width: 1280px) {
	.section01 .inner-section {
		max-width: 1920px;
		padding-left: 0;
		padding-right: 0;
	}
	.pc-web-slider {
		padding-bottom: 60px;
	}
	.pc-web-wrap {
		max-width: 1280px;
		margin: 0 auto 50px;
		padding: 0 20px;
	}
	.pc-web-wrap .sub-text span {
		display: block;
	}
	.pc-web-polygon {
		margin-bottom: 120px;
		padding-top: 70px;
		background-image: url(/static/img/project-detail/ipark-duty-free/pc-web-bg-polygon@w.png);
		background-position-y: 0;
	}
	.pc-web-polygon:before {
		top: 176px;
		left: calc(50% - 640px - 12px);
		width: 604px;
		height: 604px;
		background-image: url(/static/img/project-detail/ipark-duty-free/pc-web-img-05-02@w.png);
		background-size: 100% auto;
	}
	.pc-web-polygon .img {
		max-width: 1280px;
		margin: 0 auto;
		text-align: right;
	}
	.pc-web-polygon .img img {
		width: auto;
	}
	.pc-web-img-wrap img {
		height: auto;
	}
}

/* Mobile Web */
.mobile-web-wrap {
	padding: 0 15px 4.35393vw;
}
.mobile-img-wrap {
	background: url(/static/img/project-detail/ipark-duty-free/mobile-web-bg@m.png)
		no-repeat;
	background-size: 31.5625vw auto;
	background-position: 50% 94px;
}
.mobile-img-wrap .img {
	float: left;
}
.mobile-img-wrap .img:nth-child(odd) {
	float: right;
}
.mobile-img-wrap .item02 {
	margin-top: 53.4375vw;
}
.mobile-img-wrap .item03 {
	margin-top: 23.4375vw;
}
.mobile-img-wrap .item04 {
	margin-top: 15.625vw;
}
.mobile-img-wrap .img img {
	width: 42.03125vw;
}
.mobile-web-polygon {
	margin-top: -32px;
	padding: 32px 15px 0;
	background: url(/static/img/project-detail/ipark-duty-free/mobile-web-bg-polygon@m.png)
		no-repeat;
	background-size: 100% auto;
	text-align: center;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section02 .inner-section {
		position: relative;
	}
	.mobile-web-wrap {
		position: absolute;
		top: 0;
		left: 0;
		padding-left: 40px;
	}
	.mobile-web-wrap .sub-text span {
		display: block;
	}
	.mobile-img-wrap {
		padding: 45px 80px 6.32022vw 70px;
		background-image: url(/static/img/project-detail/ipark-duty-free/mobile-web-bg@t.png);
		background-size: 26.89607vw auto;
		background-position-y: 150px;
	}
	.mobile-img-wrap .item02 {
		margin-top: 46.76966vw;
	}
	.mobile-img-wrap .item03 {
		margin-top: 35.11235vw;
	}
	.mobile-img-wrap .item04 {
		margin-top: 23.17415vw;
	}
	.mobile-img-wrap .img img {
		width: 31.60112vw;
	}
	.mobile-web-polygon {
		padding: 0 68px 50px;
		background-image: url(/static/img/project-detail/ipark-duty-free/mobile-web-bg-polygon@t.png);
		background-position-y: 34px;
	}
}
@media screen and (min-width: 1280px) {
	.section02 .inner-section {
		max-width: 1920px;
		padding: 35px 0 0;
	}
	.mobile-web-wrap {
		top: 90px;
		left: calc(50% - 640px);
		width: 340px;
		padding-left: 20px;
	}
	.mobile-web-wrap .sub-text span {
		display: inline;
	}
	.mobile-img-wrap {
		max-width: 1280px;
		margin: 0 auto;
		padding: 0 50px 60px 50px;
		background-image: url(/static/img/project-detail/ipark-duty-free/mobile-web-bg@w.png);
		background-size: 383px auto;
		background-position-y: 157px;
	}
	.mobile-img-wrap .item02 {
		margin-top: 574px;
	}
	.mobile-img-wrap .item03 {
		margin-top: 500px;
	}
	.mobile-img-wrap .item04 {
		margin-top: 335px;
	}
	.mobile-img-wrap .img img {
		width: 450px;
	}
	.mobile-web-polygon {
		margin-top: -170px;
		padding: 170px 0 80px;
		background-image: url(/static/img/project-detail/ipark-duty-free/mobile-web-bg-polygon@w.png);
		background-position-y: 0;
	}
	.mobile-web-polygon .img {
		max-width: 1280px;
		margin: 0 auto;
	}
}

.section03 {
	position: relative;
	background-color: #ededed;
}
.section03:before {
	content: "";
	position: absolute;
	top: -40px;
	left: 50%;
	width: 1px;
	height: 80px;
	background-color: #222;
}
.section03 .inner-section {
	padding-top: 40px;
	padding-bottom: 50px;
}
.point-top-wrap {
	margin-bottom: 30px;
}
.point-top-wrap .font-area {
	margin-bottom: 30px;
}
.point-top-wrap .color-area {
	max-width: 202px;
	margin: 0 auto;
}
.point-top-wrap .color-area li {
	float: left;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 50%;
	height: 101px;
	color: #fff;
}
.point-top-wrap .color-area .item01 {
	background-color: #e83030;
}
.point-top-wrap .color-area .item02 {
	background-color: #8d7865;
}
.point-top-wrap .color-area .item03 {
	background-color: #453b31;
}
.point-top-wrap .color-area .item04 {
	background-color: #333333;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section03 .inner-section {
		padding-bottom: 40px;
		padding-left: 45px;
		padding-right: 40px;
	}
	.point-top-wrap {
		margin-bottom: 38px;
	}
	.point-top-wrap .font-area {
		float: left;
		width: 45.15449vw;
		margin-bottom: 0;
	}
	.point-top-wrap .color-area {
		float: right;
		max-width: 18.3988vw;
		padding: 8px 0;
	}
	.point-top-wrap .color-area li {
		width: 9.1994vw;
		height: 9.1994vw;
		font-size: 12px;
	}
}
@media screen and (min-width: 1280px) {
	.section03:before {
		top: -100px;
		height: 200px;
	}
	.section03 .inner-section {
		padding: 120px 20px 110px;
	}
	.point-top-wrap {
		margin-bottom: 60px;
	}
	.point-top-wrap .font-area {
		width: 643px;
	}
	.point-top-wrap .color-area {
		max-width: 224px;
		padding: 17px 0 0;
	}
	.point-top-wrap .color-area li {
		width: 112px;
		height: 112px;
		font-size: 18px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/ipark-duty-free.vue